/* global define, exports, jQuery, module, require, window */
(function(factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function($) {
    'use strict';

    var superboxContent = '@@Superbox.Content';
    var superboxIndex = '@@Superbox.Index';

    function Superbox(parent, o) {
        var me = this;
        me.options = $.extend(
            {
                getItems: function($p) {
                    return $p.find('.item');
                },
                getContent: function(o) {
                    return $(o).next();
                },
            },
            o
        );

        me.$active = null;
        me.$parent = $(parent);
        me.$contents = $();
        me.$items = me.options.getItems(me.$parent);

        var reposition = me.reposition.bind(me);

        // set up item-content link, list of contents
        me.$items.each(function(i) {
            var $content = me.options.getContent(this);
            var $item = $(this);

            $item.data(superboxContent, $content).data(superboxIndex, i);
            me.$contents = me.$contents.add($content);

            $content.find('.close').click(me.close.bind(me));
        });

        me.$items.click(function() {
            var $item = $(this);

            // just turn off current
            if ($item.hasClass('active')) {
                return me.close();
            }

            me.$contents.removeClass('active');
            me.$items.removeClass('active').addClass('inactive');
            $item.removeClass('inactive').addClass('active');

            me.$active = $item;
            $item.data(superboxContent).addClass('active');
            reposition($item);
        });

        $(window).resize(function() {
            reposition(me.$active);
        });
    }

    Superbox.prototype.close = function() {
        this.$items.removeClass('active inactive');
        this.$contents.removeClass('active');
        this.$active = null;
    };

    Superbox.prototype.reposition = function($item) {
        if (!$item) {
            return;
        }

        var $content = $item.data(superboxContent);
        var i = $item.data(superboxIndex);
        var cols = this.options.getColumnCount();
        var row = Math.floor(i / cols);
        var destination = (row + 1) * cols - 1;
        if (destination >= this.$items.length) {
            destination = this.$items.length - 1;
        }

        $content.detach().insertAfter(this.$items[destination]);
    };

    $.fn.superbox = function(options) {
        for (var i = 0; i < this.length; i++) {
            this[i].superbox = new Superbox(this[i], options);
        }
    };
});
